export default __webpack_public_path__ + "static/media/FO.5972cb50.svg";